import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StoreIcon from '@mui/icons-material/Store';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PeopleIcon from '@mui/icons-material/People';
import styles from './LandingPageV4.module.css';

const trustItems = [
  { Icon: PeopleIcon, text: '500K+', subtext: 'Happy Customers' },
  { Icon: LocalShippingIcon, text: '2M+', subtext: 'Orders Processed' },
  { Icon: StoreIcon, text: '1,000+', subtext: 'Partner Stores' },
  { Icon: AccessTimeIcon, text: '30min', subtext: 'Avg. Delivery' },
];

const TrustBar = () => (
  <section
    className={styles.trustBar}
    aria-label="Quickvee marketplace highlights"
  >
    <div className={styles.trustBarCard}>
      <div className={styles.trustBarGrid}>
        {trustItems.map(({ Icon, text, subtext }, index) => (
          <div key={index} className={styles.trustItem}>
            <div className={styles.trustIcon}>
              <Icon sx={{ fontSize: 24 }} aria-hidden />
            </div>
            <div className={styles.trustTextWrap}>
              <div className={styles.trustText}>{text}</div>
              <div className={styles.trustSubtext}>{subtext}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBar;
